import { Injectable } from '@angular/core';
import { AppConfiguration } from './app-configuration';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  configuration: Partial<AppConfiguration> = {};
}
